/* Embroidery Inc industry landing pages (2026-10). Progressive enhancement only: every section is
   fully server-rendered and works without this file. Loaded once (deferred) by
   snippets/ei-industry-assets. No dependencies, no third-party calls.
   - Crew kits: recalculates per-person and crew totals for the picked crew size
     (same rules as snippets/ei-industry-kit-price: 12+ items 5%, 24+ 10%, 48+ 15%,
     $30 digitizing fee under 12 items, integer cents).
   - Proof wall hero: pause button, pauses off-screen and in hidden tabs.
   - Product picks: Hats / Shirts / Layers filter chips.
   - Proof gallery: <dialog> lightbox with previous / next.
   - Quote form: brings the success or error message into view after the post reloads the page.
   - Theme editor: re-inits a section after it reloads and never leaves it hidden by the reveal. */
(function () {
  'use strict';
  if (window.__eiIndustry) return;
  window.__eiIndustry = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function still() { return (mq && mq.matches) || !!(navigator.connection && navigator.connection.saveData); }
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function setText(el, s) { if (el && el.textContent !== s) el.textContent = s; }

  /* Sections marked data-ei-cv use content-visibility: auto and only hold an estimated height until
     shown. Render the ones above a target first so a scroll lands where it should. */
  function settle(target) {
    each(document, '[data-ei-cv]', function (cv) {
      if (cv.compareDocumentPosition(target) & 4) cv.style.contentVisibility = 'visible';
    });
  }

  /* ---------- Crew kits ---------- */
  function tierFor(n) { return n >= 48 ? 15 : n >= 24 ? 10 : n >= 12 ? 5 : 0; }
  function initKits(root) {
    if (root.__eiInd) return;
    root.__eiInd = true;
    var ds = root.dataset;
    var fee = parseInt(ds.fee || '3000', 10);
    var waive = parseInt(ds.waive || '12', 10);
    var feeText = ds.feeText || '$30';
    var noun = ds.noun || 'Crew';
    var fmt;
    try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: ds.currency || 'USD' }); }
    catch (e) { fmt = { format: function (v) { return '$' + v.toFixed(2); } }; }
    function money(c) { return fmt.format(Math.round(c) / 100); }
    var live = root.querySelector('[data-ei-ind-live]');

    function setCrew(crew) {
      each(root, '[data-crew]', function (b) { b.setAttribute('aria-pressed', String(parseInt(b.dataset.crew, 10) === crew)); });
      each(root, '[data-kit]', function (k) {
        var cents = parseInt(k.dataset.cents, 10) || 0;
        var per = parseInt(k.dataset.items, 10) || 1;
        var items = crew * per;
        var pct = tierFor(items);
        var list = cents * crew;
        var total = Math.round(list * (100 - pct) / 100) + (items < waive ? fee : 0);
        var pp = Math.round(total / crew);
        var q = function (n) { return k.querySelector('[data-k="' + n + '"]'); };
        setText(q('pp'), money(pp));
        var strike = q('list');
        if (strike) strike.hidden = pct === 0;
        var tier = q('tier');
        if (tier) { setText(tier, pct ? pct + '% off' : 'Standard price'); tier.classList.toggle('is-base', !pct); }
        setText(q('items'), items + ' items');
        setText(q('fee'), items < waive ? 'includes the ' + feeText + ' digitizing fee' : 'digitizing fee waived');
        setText(q('crew'), noun + ' of ' + crew);
        setText(q('total'), money(total));
      });
      if (live) setText(live, 'Prices updated for a ' + noun.toLowerCase() + ' of ' + crew + '.');
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-crew]') : null;
      if (b && root.contains(b)) setCrew(parseInt(b.dataset.crew, 10) || 1);
    });
  }

  /* ---------- Proof wall hero ---------- */
  function initWall(root) {
    if (root.__eiInd) return;
    root.__eiInd = true;
    var btn = root.querySelector('[data-ei-ind-pause]');
    var manual = false;
    function sync(off) {
      root.classList.toggle('is-paused', manual || off || document.hidden);
    }
    if (btn) btn.addEventListener('click', function () {
      manual = !manual;
      btn.setAttribute('aria-pressed', manual ? 'true' : 'false');
      btn.setAttribute('aria-label', manual ? 'Play the moving proof photos' : 'Pause the moving proof photos');
      sync(false);
    });
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; sync(!visible); }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { sync(!visible); });
  }

  /* ---------- Product picks filter ---------- */
  function initPicks(root) {
    if (root.__eiInd) return;
    root.__eiInd = true;
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-f]') : null;
      if (!b || !root.contains(b)) return;
      var f = b.dataset.f;
      each(root, '[data-f]', function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      each(root, '[data-group]', function (li) {
        li.hidden = f !== 'all' && li.dataset.group !== f;
        li.classList.add('is-in');
      });
    });
  }

  /* ---------- Proof gallery lightbox ---------- */
  function initLightbox(grid) {
    if (grid.__eiInd) return;
    grid.__eiInd = true;
    var section = grid.closest('section') || document;
    var dlg = section.querySelector('[data-ei-ind-lb-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    document.body.appendChild(dlg);
    var img = dlg.querySelector('[data-ei-ind-lb-img]');
    var cap = dlg.querySelector('[data-ei-ind-lb-cap]');
    var prev = dlg.querySelector('[data-ei-ind-lb-prev]');
    var next = dlg.querySelector('[data-ei-ind-lb-next]');
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-ei-ind-lb-item]'));
    var at = 0;
    var opener = null;
    if (items.length < 2) { prev.hidden = true; next.hidden = true; }

    function show(i) {
      at = (i + items.length) % items.length;
      var a = items[at];
      var alt = a.getAttribute('data-alt') || '';
      img.src = a.href;
      img.alt = alt;
      setText(cap, alt);
    }
    grid.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-ei-ind-lb-item]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      opener = a;
      show(items.indexOf(a));
      dlg.showModal();
    });
    prev.addEventListener('click', function () { show(at - 1); });
    next.addEventListener('click', function () { show(at + 1); });
    dlg.querySelector('[data-ei-ind-lb-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
    });
    dlg.addEventListener('close', function () { if (opener) opener.focus({ preventScroll: true }); });
  }

  /* ---------- Quote form result ---------- */
  function focusQuoteResult() {
    var r = document.querySelector('[data-ei-ind-quote-result]');
    if (!r) return;
    settle(r);
    r.scrollIntoView({ block: 'center', behavior: still() ? 'auto' : 'smooth' });
    r.focus({ preventScroll: true });
  }

  function init(scope) {
    var root = scope || document;
    each(root, '[data-ei-ind-kits]', initKits);
    each(root, '[data-ei-ind-wall]', initWall);
    each(root, '[data-ei-ind-picks]', initPicks);
    each(root, '[data-ei-ind-lb]', initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); focusQuoteResult(); });
  } else {
    init();
    focusQuoteResult();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    each(t, '.ei-reveal', function (el) { el.classList.add('is-in'); });
    init(t);
  });
})();
